module.exports = __webpack_public_path__ + "static/tab-hell-3c8c2837dd1f17f2ff533c15885e08fc.png";